import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Collapse, IconButton } from '@mui/material';
import clsx from 'clsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const CardExplanationMutation = (props) => {

  const { mutationType } = props;

  const { t } = useTranslation();

  const classes = useStyles();
  const [ isExpanded, setExpanded ] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!isExpanded);
  };

  return (
    <Card className={`card-explanation-mutation ${mutationType}`}>
      <CardHeader
        title={t(`modal_title_${mutationType}`.toLowerCase())}
        action={
          <IconButton
            className={clsx(classes.expand, {
              [ classes.expandOpen ]: isExpanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={isExpanded}
            aria-label="show more"
            size="large">
            <ExpandMoreIcon />
          </IconButton>
        } />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent sx={{
          maxHeight: '25rem',
          overflow: 'auto',
        }}>
          {props.children}
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default memo(CardExplanationMutation);

